import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api, authApi, candidateApi } from "../../config/api";
import { toast } from "react-toastify";

// Async thunk for get all bench sales candidate list
export const getAllCandidate = createAsyncThunk(
  "all/candidate",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get(
        `/candidate/resume/profile/all/?${queryParams}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all bench sales candidate list
export const getOneCandidate = createAsyncThunk(
  "on/candidate",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get(
        `/candidate/resume/profile/${ID}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for view search candidate details
export const viewSearchCandidate = createAsyncThunk(
  "view/candidate",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/recruiter/view-count-update/${ID}/?candidate=resume_profile_candidate`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for create candidate  if the candidate not exist
export const createCandidateProfile = createAsyncThunk(
  "create/candidateprofile",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authApi.post("/auth/signup", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for create candidate resume if the candidate exist
export const createExistCandidateProfile = createAsyncThunk(
  "create/candidateexistprofile",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.post(
        "/candidate/resume/profile/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update post requirement
export const updateExistCandidateProfile = createAsyncThunk(
  "update/postrequirement",
  async ({ values, jobId }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/req/job/update/${jobId}/`, values);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update post requirement
export const deleteCandidateProfile = createAsyncThunk(
  "delete/resume/profile",
  async (candidateID, { rejectWithValue }) => {
    try {
      const response = await candidateApi.delete(
        `/candidate/resume/profile/${candidateID}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get the data of if the candidate exist or not
export const checkCandidateExist = createAsyncThunk(
  "get/candidate/exist",
  async ({ email, mobile_no }, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        `/auth/check-candidate-exist?email=${email}&mobile_no=${mobile_no}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all bench sales candidate list
export const getAllRequirementCount = createAsyncThunk(
  "all/candidate/requirement/count",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/req/requirements/dashboard/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all bench sales candidate list
export const getAllRequirementCountForCandidate = createAsyncThunk(
  "all/candidate/requirement/count/candidate",
  async (quiry, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/req/requirements/dashboard/?requested_user_id=${quiry}&requested_user_role=CANDIDATE`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update candidate action
export const updateActionCandidateProfile = createAsyncThunk(
  "action/candidateprofile",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.post(
        "/candidate/resume/profile/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get the data of if the candidate exist or not
export const checkCandidateResumeProfile = createAsyncThunk(
  "get/candidate/exist-resume-profile",
  async (email, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get(
        `/candidate/resume/profile/check-resume-profile/?candidate_email=${email}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resumeStatusChange = createAsyncThunk(
  "resume/status/change",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.put(
        "/candidate/resume/resume-profile/active/update/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resumeStatusChangeAdd = createAsyncThunk(
  "resume/status/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.post(
        "/candidate/resume/resume-status/manage/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resumeStatusChangeDelete = createAsyncThunk(
  "resume/status/update",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.delete(
        "/candidate/resume/resume-status/manage/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const mutualCandidateProfile = createAsyncThunk(
  "get/candidate/mutual-list",
  async (email, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get(
        `candidate/resume/mutual-status/list/?email=${email}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBenchsalesByMail = createAsyncThunk(
  "get/candidate/benchsales",
  async (email, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        `/auth/user/profile-details/?email=${email}&role=BENCH_SALES_RECRUITER`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const candidateSlice = createSlice({
  name: "candidate",
  initialState: {
    data: null,
    searchData: null,
    countData: null,
    countDataCandidate: null,
    candidateExistResumeData: null,
    mutualCandidate: null,
    singleCandidateData: null,
    benchsalesData: null,
    singleCandidateStatus: "idle",
    selectedCandidate: null,
    status: "idle",
    error: null,
  },
  reducers: {
    // Add a reducer to set the selected candidate
    setSelectedCandidate: (state, action) => {
      state.selectedCandidate = action.payload;
    },
    // Optional: Clear selected candidate if needed
    clearSelectedCandidate: (state) => {
      state.selectedCandidate = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCandidate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllCandidate.fulfilled, (state, action) => {
        state.status = "get_all_candidate_succeded";
        state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getAllCandidate.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(createCandidateProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createCandidateProfile.fulfilled, (state, action) => {
        state.status = "create_candidate_profile";
        toast.success(action.payload.message);
      })
      .addCase(createCandidateProfile.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload.message);
      })
      .addCase(createExistCandidateProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createExistCandidateProfile.fulfilled, (state, action) => {
        state.status = "create_candidate_exist_profile";
        toast.success(action.payload?.message);
      })
      .addCase(createExistCandidateProfile.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updateExistCandidateProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateExistCandidateProfile.fulfilled, (state, action) => {
        state.status = "update_candidate_exist_profile";
        toast.success(action.payload?.message);
      })
      .addCase(updateExistCandidateProfile.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(checkCandidateExist.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkCandidateExist.fulfilled, (state, action) => {
        state.status = "get_search_requirement";
        state.searchData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(checkCandidateExist.rejected, (state, action) => {
        state.status = "failed";
        // toast.error(action.payload?.message);
      })
      .addCase(getAllRequirementCount.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllRequirementCount.fulfilled, (state, action) => {
        state.status = "get_all_count_succeded";
        state.countData = action.payload;
        toast.success(action.payload?.message);
      })
      .addCase(getAllRequirementCount.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getAllRequirementCountForCandidate.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(
        getAllRequirementCountForCandidate.fulfilled,
        (state, action) => {
          state.singleCandidateStatus = "get_all_count_candidate_succeded";
          state.countDataCandidate = action.payload;
          toast.success(action.payload?.message);
        }
      )
      .addCase(getAllRequirementCountForCandidate.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updateActionCandidateProfile.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(updateActionCandidateProfile.fulfilled, (state, action) => {
        state.singleCandidateStatus = "update_candidate_action";
        toast.success(action.payload?.message);
      })
      .addCase(updateActionCandidateProfile.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(checkCandidateResumeProfile.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkCandidateResumeProfile.fulfilled, (state, action) => {
        state.status = "check_candidate_profile";
        state.candidateExistResumeData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(checkCandidateResumeProfile.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getOneCandidate.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(getOneCandidate.fulfilled, (state, action) => {
        state.singleCandidateStatus = "get_one_candidate_succed";
        state.singleCandidateData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getOneCandidate.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(resumeStatusChange.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(resumeStatusChange.fulfilled, (state, action) => {
        state.singleCandidateStatus = "resume_change-status-success";
        // toast.success(action.payload?.message);
      })
      .addCase(resumeStatusChange.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(resumeStatusChangeAdd.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(resumeStatusChangeAdd.fulfilled, (state, action) => {
        state.singleCandidateStatus = "add_resume_status_add_success";
        toast.success(action.payload?.message);
      })
      .addCase(resumeStatusChangeAdd.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(deleteCandidateProfile.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(deleteCandidateProfile.fulfilled, (state, action) => {
        state.singleCandidateStatus = "delete_candidate_profile_success";
        toast.success(action.payload?.message);
      })
      .addCase(deleteCandidateProfile.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })

      .addCase(resumeStatusChangeDelete.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(resumeStatusChangeDelete.fulfilled, (state, action) => {
        state.singleCandidateStatus = "delete_resume_status_success";
        toast.success(action.payload?.message);
      })
      .addCase(resumeStatusChangeDelete.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(mutualCandidateProfile.pending, (state) => {
        state.singleCandidateStatus = "loading";
      })
      .addCase(mutualCandidateProfile.fulfilled, (state, action) => {
        state.singleCandidateStatus = "candidate_mutual_list";
        state.mutualCandidate = action.payload;
      })
      .addCase(mutualCandidateProfile.rejected, (state, action) => {
        state.singleCandidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getBenchsalesByMail.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getBenchsalesByMail.fulfilled, (state, action) => {
        state.status = "benchsales_details";
        state.benchsalesData = action.payload;
      })
      .addCase(getBenchsalesByMail.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export const { setSelectedCandidate, clearSelectedCandidate } =
  candidateSlice.actions;
export default candidateSlice.reducer;
